import { ActionReducerMap } from '@ngrx/store';
import { AppState } from '../states/app.state';
import { currentUserReducer } from './user.reducer';

export const reducers: ActionReducerMap<AppState> = {
  currentUser: currentUserReducer,
};
